import { detailsEditorTab, editorSection } from '../../pageEditTabs';

const SECTION_PATHS = { images: '/image-gallery', files: '/file-downloads' };

export const UPLOAD_LABELS = { images: 'Upload images', files: 'Upload files' };

export const UPLOAD_TITLES = { images: 'Add your own images', files: 'Add your own files' };

// The editor section an upload lands in: on a checkout page that is the product's, under the Product tab.
export function uploadSection(kind, pageType) {
  const tab = detailsEditorTab(pageType);
  const path = Object.hasOwn(SECTION_PATHS, kind) ? SECTION_PATHS[kind] : undefined;
  const section = tab && path ? editorSection(tab, path, { page: { type: pageType } }) : undefined;
  return section ? { label: section.label, route: `/${tab}${path}` } : null;
}
